import { useQuery } from "@tanstack/react-query";

import { Data, DataMany } from "@/shared/types.ts";
import ky from "@/shared/api";
import { UserEntity } from "@/features/users/type.ts";

// Ключи кеша вынесены, чтобы мутации в use-user.ts инвалидировали ровно те же
// запросы: карточку пользователя и список.
export const USER_KEY = "user";
export const USERS_KEY = "users";

export function useUser(userId: string) {
  return useQuery<Data<UserEntity>>({
    queryKey: [USER_KEY, userId],
    queryFn: (ctx) =>
      ky
        .get<
          Data<UserEntity>
        >(`/api/users/get/by/id/${userId}`, { signal: ctx.signal })
        .json(),
  });
}

export function useUsers({
  skip,
  cityId,
  role,
  phone,
  name,
}: {
  cityId?: number;
  role?: string;
  phone?: string;
  name?: string;
  skip?: number;
}) {
  return useQuery<DataMany<UserEntity[]> | undefined>({
    queryKey: [USERS_KEY, { skip, cityId, role, phone, name }],
    queryFn: (ctx) =>
      ky
        .get<DataMany<UserEntity[]> | undefined>(`/api/users/get/all`, {
          signal: ctx.signal,
          // ky выбрасывает undefined-значения, поэтому пустые фильтры
          // в query-строку не попадают.
          searchParams: {
            cityId,
            role,
            phone,
            name,
            skip: skip ? (skip - 1) * 12 : 0,
            limit: 12,
          },
        })
        .json(),
    placeholderData: (previous) => previous,
  });
}
